import { mixed, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    return object().shape({
        file: mixed().required(REQUIRED_TEXT).nullable(),
        name: string().required(REQUIRED_TEXT).nullable(),
        system: string().required(REQUIRED_TEXT).nullable(),
    });
};
